/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForBackupData extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForBackupData.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForBackupData>): ProgressDetailsForBackupData {
        let obj = Object.assign(new ProgressDetailsForBackupData(), model);
        ProgressDetailsForBackupData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForBackupData>): ProgressDetailsForBackupData {
        if (!model) return null;
        return ProgressDetailsForBackupData.newInstance(<ProgressDetailsForBackupData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForBackupData) {
        if (!obj) return;

        models.ProgressDetailsForBackupData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForBackupData): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForBackupData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Prefill Flag
     */
    pre_fill: boolean;

}
